import React, { useCallback, useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import { IssueGroup } from '../../data/issueTypes';
interface NestedSelectProps {
  groups: IssueGroup[];
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  error?: boolean;
}
export function NestedSelect({
  groups,
  value,
  placeholder,
  onChange,
  error
}: NestedSelectProps) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState<string | null>(null);
  const close = useCallback(() => {
    setOpen(false);
    setHovered(null);
  }, []);
  const ref = useOutsideClick<HTMLDivElement>(close);
  return <div ref={ref} className="relative" data-id="element-348" data-mp="2ccnvf15nntzb">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className={`flex h-9 w-full items-center justify-between gap-2 rounded border bg-white px-3 text-left text-[13px] focus:outline-none focus:ring-1 ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-400' : 'border-ink-300 focus:border-brand-500 focus:ring-brand-500'} ${value ? 'text-ink-800' : 'text-ink-400'}`} data-id="element-349" data-mp="2cdp97de22ukq">
        <span className="truncate" data-id="element-350" data-mp="1n71a1zlnf53h">{value || placeholder}</span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink-400 ${open ? 'rotate-180' : ''}`} data-id="element-351" data-mp="1s4sxagbcm31c" />
      </button>

      {open && <div className="absolute left-0 top-10 z-40 w-full min-w-[240px] rounded border border-ink-200 bg-white py-1 shadow-pop" data-id="element-352" data-mp="2fvovpwab7whk">
          {groups.map(group => <div key={group.label} className="relative" onMouseEnter={() => setHovered(group.label)} onMouseLeave={() => setHovered(null)} data-id="element-353" data-mp="262zppgxj3atm">
              <button type="button" onClick={() => setHovered(group.label)} className={`flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-[13px] ${hovered === group.label ? 'bg-ink-50 text-ink-900' : 'text-ink-700'}`} data-id="element-354" data-mp="2yqvkuh7g8uoa">
                {group.label}
                <ChevronRightIcon className="h-4 w-4 text-ink-400" data-id="element-355" data-mp="33g7muvrdsf4s" />
              </button>
              {hovered === group.label && <ul className="absolute left-full top-0 z-50 ml-0.5 w-60 rounded border border-ink-200 bg-white py-1 shadow-pop" data-id="element-356" data-mp="2zf4cupw0ldbh">
                  {group.options.map(option => {
            const label = option;
            return <li key={option} data-id="element-357" data-mp="2kpq1jc8voltg">
                        <button type="button" onClick={() => {
                onChange(label);
                close();
              }} className={`block w-full px-3 py-2 text-left text-[13px] hover:bg-ink-50 ${value === label ? 'font-semibold text-brand-700' : 'text-ink-700'}`} data-id="element-358" data-mp="2kqrb1ca8x092">
                          {option}
                        </button>
                      </li>;
          })}
                </ul>}
            </div>)}
        </div>}
    </div>;
}